// Calendar dates (YYYY-MM-DD) should always use the user's local timezone,
// not UTC via toISOString(), so dates stay consistent worldwide.

export const getLocalDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseLocalDateString = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/** Normalize DB date/timestamptz values to YYYY-MM-DD for string comparison. */
export const normalizeDateString = (value) => {
  if (value == null || value === '') {
    return null;
  }

  return String(value).slice(0, 10);
};

export const isPricingActiveOnDate = (service, dateStr) => {
  const date = normalizeDateString(dateStr);
  const validFrom = normalizeDateString(service?.pricing_valid_from);
  const validUntil = normalizeDateString(service?.pricing_valid_until);

  if (validFrom && validFrom > date) {
    return false;
  }

  if (validUntil && validUntil < date) {
    return false;
  }

  return true;
};
